/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import React, { styled, css } from 'fierry/react.old';

import * as EnergyValue from 'astro/value/energy';
import * as InfluenceValue from 'astro/value/influence';


const getInfluenceAdvantage = ({ zone }) =>
{
  return zone.getAttributes().getInfluenceAdvantage();
}


const isCurrentOwnerWinner = ({ zone }) =>
{
  return zone.getAttributes().getInfluenceWinner() === zone.getCass().getUser();
}


const getBackgroundOpacity = (props) =>
{
  const value = getInfluenceAdvantage(props);

  if (value >= 5) { return 0.00; }
  if (value >= 4) { return 0.05; }
  if (value >= 3) { return 0.10; }
  if (value >= 2) { return 0.15; }
  if (value >= 1) { return 0.20; }
  if (value >= 0) { return 0.25; }

  return 0.4;
}


const opacityConfig = (props) => css`
  --svg-opacity: ${getBackgroundOpacity(props)};
`;


const ownerNotWinnerConfig = (props) => !isCurrentOwnerWinner(props) && css`
  mask: url(#decrease.stripe);
`;


const Polygon = styled.polygon`
  fill: var(--svg-always-black);
  fill-opacity: var(--svg-opacity);

  ${opacityConfig}
  ${ownerNotWinnerConfig}
`;


const getPolygonPoints = ({ grid, location }) =>
{
  const callback = ({ x, y }) => `${x},${y}`;

  return grid.getLocalHex(location).getZonePoints().map(callback).join(' ');
}


export default (props) =>
(
  <Polygon {...props}
    points = {getPolygonPoints(props)}
  />
);
